<template>
    <div class="content">
        <h1>Event Colors</h1>

        <div class="colors">
            <template v-for="(color, key) in data.event">
                <div :style="{'background-color': color.background, color: color.foreground}">
                    ID: {{key}} background: {{color.background}}
                </div>
            </template>
        </div>

        <h1>Calendar Colors</h1>

        <div class="colors">
            <template v-for="(color, key) in data.calendar">
                <div :style="{'background-color': color.background, color: color.foreground}">
                    ID: {{key}} background: {{color.background}}
                </div>
            </template>
        </div>
    </div>
</template>

<style>
.colors {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 1em;
}
.colors div {
    white-space: nowrap;
    border-radius: 5px;
    font-size: 1.2em;
    font-weight: bold;
    padding: 0.5em;
}
</style>

<script>
export default {
    name: "colors",
    data() {
        return {
            data: {
                calendar: {
                    "1": {
                        background: "#ac725e",
                        foreground: "#1d1d1d"
                    },
                    "2": {
                        background: "#d06b64",
                        foreground: "#1d1d1d"
                    },
                    "3": {
                        background: "#f83a22",
                        foreground: "#1d1d1d"
                    },
                    "4": {
                        background: "#fa573c",
                        foreground: "#1d1d1d"
                    },
                    "5": {
                        background: "#ff7537",
                        foreground: "#1d1d1d"
                    },
                    "6": {
                        background: "#ffad46",
                        foreground: "#1d1d1d"
                    },
                    "7": {
                        background: "#42d692",
                        foreground: "#1d1d1d"
                    },
                    "8": {
                        background: "#16a765",
                        foreground: "#1d1d1d"
                    },
                    "9": {
                        background: "#7bd148",
                        foreground: "#1d1d1d"
                    },
                    "10": {
                        background: "#b3dc6c",
                        foreground: "#1d1d1d"
                    },
                    "11": {
                        background: "#fbe983",
                        foreground: "#1d1d1d"
                    },
                    "12": {
                        background: "#fad165",
                        foreground: "#1d1d1d"
                    },
                    "13": {
                        background: "#92e1c0",
                        foreground: "#1d1d1d"
                    },
                    "14": {
                        background: "#9fe1e7",
                        foreground: "#1d1d1d"
                    },
                    "15": {
                        background: "#9fc6e7",
                        foreground: "#1d1d1d"
                    },
                    "16": {
                        background: "#4986e7",
                        foreground: "#1d1d1d"
                    },
                    "17": {
                        background: "#9a9cff",
                        foreground: "#1d1d1d"
                    },
                    "18": {
                        background: "#b99aff",
                        foreground: "#1d1d1d"
                    },
                    "19": {
                        background: "#c2c2c2",
                        foreground: "#1d1d1d"
                    },
                    "20": {
                        background: "#cabdbf",
                        foreground: "#1d1d1d"
                    },
                    "21": {
                        background: "#cca6ac",
                        foreground: "#1d1d1d"
                    },
                    "22": {
                        background: "#f691b2",
                        foreground: "#1d1d1d"
                    },
                    "23": {
                        background: "#cd74e6",
                        foreground: "#1d1d1d"
                    },
                    "24": {
                        background: "#a47ae2",
                        foreground: "#1d1d1d"
                    }
                },
                event: {
                    "1": {
                        background: "#a4bdfc",
                        foreground: "#1d1d1d"
                    },
                    "2": {
                        background: "#7ae7bf",
                        foreground: "#1d1d1d"
                    },
                    "3": {
                        background: "#dbadff",
                        foreground: "#1d1d1d"
                    },
                    "4": {
                        background: "#ff887c",
                        foreground: "#1d1d1d"
                    },
                    "5": {
                        background: "#fbd75b",
                        foreground: "#1d1d1d"
                    },
                    "6": {
                        background: "#ffb878",
                        foreground: "#1d1d1d"
                    },
                    "7": {
                        background: "#46d6db",
                        foreground: "#1d1d1d"
                    },
                    "8": {
                        background: "#e1e1e1",
                        foreground: "#1d1d1d"
                    },
                    "9": {
                        background: "#5484ed",
                        foreground: "#1d1d1d"
                    },
                    "10": {
                        background: "#51b749",
                        foreground: "#1d1d1d"
                    },
                    "11": {
                        background: "#dc2127",
                        foreground: "#1d1d1d"
                    }
                }
            }
        };
    }
};
</script>
